import { VideoActions } from "../actions/video";

const INITIAL_STATE = {
  playback: {},
  videos: {
    loading: true,
  },
};

function video(state = INITIAL_STATE, action) {
  let playback, videos;
  switch (action.type) {
    case VideoActions.CREATE_VIDEO:
      videos = state.videos.slice();
      videos.push(action.payload.video);
      return {
        ...state,
        videos,
      };
    case VideoActions.DELETE_VIDEO:
    case VideoActions.GET_VIDEO:
    case VideoActions.UPDATE_VIDEO:
      videos = state.videos.map((video) =>
        video.id === action.payload.video.id ? action.payload.video : video
      );

      if (!videos.find((video) => video.id === action.payload.video.id)) {
        videos.push(action.payload.video);
      }

      return {
        ...state,
        videos,
      };
    case VideoActions.GET_VIDEO_PLAYBACK:
      playback = Object.assign({}, state.playback);
      playback[action.payload.video.id] = action.payload.video;
      return {
        ...state,
        playback,
      };
    case VideoActions.GET_VIDEOS:
      return {
        ...state,
        videos: action.payload.videos,
        loading: false,
      };
    case VideoActions.INVALIDATE_VIDEOS:
      return INITIAL_STATE;
    case VideoActions.SET_VIDEOS_LOADING:
      return {
        ...state,
        loading: action.payload,
      };
    default:
      return state;
  }
}

export default { video };
